import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
    const { t } = useLang();

    return (
        <section id="faq" data-testid="faq-section" className="relative py-20 lg:py-28 border-t border-white/5">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.7 }}
                >
                    <span className="text-xs font-extrabold uppercase tracking-[0.25em] text-volt">
                        {t("faq.eyebrow")}
                    </span>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white">
                        {t("faq.h")}
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.1 }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="mt-10 text-left"
                >
                    <Accordion type="single" collapsible className="w-full">
                        {t("faq.items").map((item, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-white/10"
                            >
                                <AccordionTrigger className="py-5 text-left text-base sm:text-lg font-extrabold text-white hover:text-volt hover:no-underline">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-sm sm:text-base leading-relaxed text-slate-400">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
};

export default FAQ;
